"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financeTransactionListResponseSchema = exports.financeReconciliationTotalsSchema = exports.financeTransactionSchema = exports.financeTransactionExportQuerySchema = exports.financeTransactionListQuerySchema = exports.financeFeeStatusSchema = exports.financeTransactionImpactSchema = exports.financeTransactionStatusSchema = exports.financeTransactionKindSchema = exports.financeLedgerCsvSchemaVersionSchema = exports.FINANCE_LEDGER_CSV_SCHEMA_VERSION = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const invoice_1 = require("./invoice");
const pagination_1 = require("./pagination");
const MAX_FINANCE_RANGE_MS = 93 * 24 * 60 * 60 * 1_000;
exports.FINANCE_LEDGER_CSV_SCHEMA_VERSION = "crewfsm.finance-ledger.v1";
exports.financeLedgerCsvSchemaVersionSchema = zod_1.z.literal(exports.FINANCE_LEDGER_CSV_SCHEMA_VERSION);
exports.financeTransactionKindSchema = zod_1.z.enum([
    "CHARGE",
    "DEPOSIT",
    "REFUND",
    "ADJUSTMENT",
    "FEE",
    "DISPUTE",
]);
exports.financeTransactionStatusSchema = zod_1.z.enum([
    "SUCCEEDED",
    "REVERSED",
    "REQUESTED",
    "PROCESSING",
    "FAILED",
    "OPEN",
    "RESOLVED_REFUNDED",
    "RESOLVED_MANUALLY",
    "RESOLVED_PROVIDER_WON",
    "NEEDS_RESPONSE",
    "UNDER_REVIEW",
    "WON",
    "LOST",
    "CLOSED",
]);
exports.financeTransactionImpactSchema = zod_1.z.enum([
    "INFLOW",
    "OUTFLOW",
    "NON_CASH",
]);
exports.financeFeeStatusSchema = zod_1.z.enum([
    "KNOWN",
    "NOT_APPLICABLE",
    "UNAVAILABLE",
]);
const financeFilterFields = {
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    locationId: business_1.operationalLocationIdSchema.optional(),
    kind: exports.financeTransactionKindSchema.optional(),
    status: exports.financeTransactionStatusSchema.optional(),
    method: invoice_1.paymentMethodSchema.optional(),
    search: zod_1.z
        .string()
        .trim()
        .min(1)
        .max(160)
        .optional()
        .transform((value) => value || undefined),
};
function validateFinanceRange(value, context) {
    const from = Date.parse(value.from);
    const to = Date.parse(value.to);
    if (to <= from) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "The end of the range must be after the start.",
        });
        return;
    }
    if (to - from > MAX_FINANCE_RANGE_MS) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "Finance ranges cannot exceed 93 days.",
        });
    }
}
exports.financeTransactionListQuerySchema = zod_1.z
    .object({
    ...financeFilterFields,
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
})
    .superRefine(validateFinanceRange);
exports.financeTransactionExportQuerySchema = zod_1.z
    .object(financeFilterFields)
    .superRefine(validateFinanceRange);
const financeInvoiceReferenceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    invoiceNumber: zod_1.z.number().int().positive(),
});
const financeJobReferenceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    summary: zod_1.z.string(),
});
const financeCustomerReferenceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    displayName: zod_1.z.string(),
});
exports.financeTransactionSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    sourceId: zod_1.z.string().uuid(),
    kind: exports.financeTransactionKindSchema,
    status: exports.financeTransactionStatusSchema,
    impact: exports.financeTransactionImpactSchema,
    occurredAt: zod_1.z.string().datetime(),
    currency: zod_1.z.literal("USD"),
    amountCents: zod_1.z.number().int().nonnegative(),
    netAmountCents: zod_1.z.number().int(),
    paymentMethod: invoice_1.paymentMethodSchema.nullable(),
    source: zod_1.z.enum(["MANUAL", "PROVIDER", "SYSTEM"]).nullable(),
    providerKey: zod_1.z.string().nullable(),
    feeCents: zod_1.z.number().int().nonnegative().nullable(),
    feeStatus: exports.financeFeeStatusSchema,
    reference: zod_1.z.string().nullable(),
    detail: zod_1.z.string().nullable(),
    relatedTransactionId: zod_1.z.string().nullable(),
    invoice: financeInvoiceReferenceSchema.nullable(),
    job: financeJobReferenceSchema.nullable(),
    customer: financeCustomerReferenceSchema.nullable(),
});
exports.financeReconciliationTotalsSchema = zod_1.z.object({
    grossInflowCents: zod_1.z.number().int().nonnegative(),
    refundOutflowCents: zod_1.z.number().int().nonnegative(),
    adjustmentOutflowCents: zod_1.z.number().int().nonnegative(),
    knownFeeCents: zod_1.z.number().int().nonnegative(),
    netCents: zod_1.z.number().int(),
    disputedCents: zod_1.z.number().int().nonnegative(),
    openReconciliationCents: zod_1.z.number().int().nonnegative(),
    openReconciliationCount: zod_1.z.number().int().nonnegative(),
    unknownProviderFeeCount: zod_1.z.number().int().nonnegative(),
});
exports.financeTransactionListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.financeTransactionSchema),
    total: zod_1.z.number().int().nonnegative(),
    totals: exports.financeReconciliationTotalsSchema,
    range: zod_1.z.object({
        from: zod_1.z.string().datetime(),
        to: zod_1.z.string().datetime(),
        businessTimezone: zod_1.z.string().min(1),
    }),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
//# sourceMappingURL=finance.js.map